var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ev-autocomplete',_vm._b({attrs:{"label":"Направленность","item-text":"name","item-value":"id","items":_vm.$options.constants.EVENT_DIRECTIONS},model:{value:(_vm.inputValue),callback:function ($$v) {_vm.inputValue=$$v},expression:"inputValue"}},'ev-autocomplete',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }